import { useEffect, useState } from 'react'
import AES from 'crypto-js/aes'
import { useStoreState, useStoreActions } from '@mortgage-pos/ui/store'
import { environment } from '@mortgage-pos/ui/env'
import incense from '@mortgage-pos/ui/services/error-handling/incense'
import { getDomain, redirectTo, setCookie } from '@mortgage-pos/utils'
import { CookieName, QuestionSetSlug } from '@mortgage-pos/types'
import { useVariation } from '../services/featureFlags'
import { FEATURE_FLAG_TYPES } from '@mortgage-pos/data'

export default function usePhoneAuthRedirect() {
  const { applicationGuid } = useStoreState((state) => state.application)
  const { isPhoneFlow } = useStoreState((state) => state.questionnaire)
  const { isAuthenticated, isCheckingAuthentication } = useStoreState(
    (state) => state.authentication
  )

  const { checkAccountByGuid } = useStoreActions(
    (state) => state.authentication
  )

  const [isCheckingForAccount, setIsCheckingForAccount] = useState(false)

  const skipBorrowerPortal = useVariation(
    FEATURE_FLAG_TYPES.SKIP_BORROWER_PORTAL
  )

  useEffect(() => {
    async function checkAccount() {
      setIsCheckingForAccount(true)

      try {
        const hasAccount = await checkAccountByGuid(applicationGuid)

        if (!isAuthenticated && hasAccount) {
          const redirectUrl = AES.encrypt(
            `${window.location.origin}/application-1003?question-set=${QuestionSetSlug.PhoneApp}`,
            environment.cryptoSecretKeyBrowser
          ).toString()
          const domain = getDomain()
          setCookie(CookieName.AuthRedirectUrl, redirectUrl, 1, domain)
          setCookie(CookieName.AppGuid, applicationGuid, 1, domain)

          if (!skipBorrowerPortal) {
            redirectTo(`${environment.borrowerPortal.uiBaseUrl}/login`)
          }

          return
        }
      } catch (e) {
        incense(e)
          .details({
            name: 'usePhoneAuthRedirectError',
            message: 'Error during checking for existing account',
          })
          .safe({
            applicationGuid,
          })
          .error()
      }
      setIsCheckingForAccount(false)
    }

    if (isPhoneFlow && !isCheckingAuthentication && !isCheckingForAccount)
      checkAccount()
  }, [
    isPhoneFlow,
    isCheckingAuthentication,
    isAuthenticated,
    setIsCheckingForAccount,
  ])

  return { isCheckingForAccount }
}
